<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: shenlin
 * @LastEditTime: 2022-02-08 18:54:56
-->
<template>
  <div class="app-container">
    <div class="header">
      <div class="header-serach">
        <el-form :inline="true" :model="ruleform">
          <el-form-item>
            <el-input
              v-model="ruleform.keyWord"
              placeholder="搜索诉求标题/企业名称"
              @change="getSearch"
              clearable
            >
              <i
                @click="getSearch"
                slot="suffix"
                class="el-input__icon el-icon-search"
              ></i
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="ruleform.videoTime"
              type="daterange"
              @change="getPoss"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="ruleform.appealType"
              placeholder="诉求分类"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in appealList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="ruleform.currentRole"
              placeholder="处理角色"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in roleList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="ruleform.county"
              placeholder="所属区县"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in areaList"
                :key="item.code"
                :label="item.county"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="ruleform.process"
              placeholder="诉求状态"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in processList"
                :key="item.code"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="addPru" @click="exportDefend">导出</div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#fafafa' }"
      height="500"
    >
    <el-table-column
        label="序号"
        width="100"
        type="index"
      ></el-table-column>
      <el-table-column
        prop="appealTitle"
        label="诉求标题"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="entName" label="企业名称">
      </el-table-column>
      <el-table-column
        prop="contact"
        label="联系人"
      ></el-table-column>
      <el-table-column prop="county" label="所属区县"></el-table-column>
      <el-table-column prop="appealType" label="诉求分类"></el-table-column>
      <el-table-column
        prop="currentProcess"
        label="诉求状态"
      >
      <template slot-scope="scope">
        <span>{{handleStatus(scope.row.currentProcess)}}</span>
      </template>
      </el-table-column>
      <el-table-column
        prop="currentRole"
        label="处理角色"
      >
      <template></template>
      </el-table-column>
       <el-table-column
        prop="createTime"
        label="发起时间"
      >
    </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span
          v-if="scope.row.isHandle==1"
            style="cursor: pointer; margin-right: 10px;color: #1890ff;"
            @click="edit(scope.row)"
            >处理</span
          >
           <span
           v-if="scope.row.isHandle==0"
            style="cursor: pointer; margin-right: 10px;color: #1890ff;"
            @click="edit(scope.row)"
            >查看</span
          >
          <span
            style="margin-right: 10px; cursor: pointer;color: #1890ff;"
            @click="deleteEntTrain(scope.row.id)"
            >删除</span
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="table-page">
      <el-pagination
        background
        layout="total,prev, pager, next, sizes, jumper"
        :current-page.sync="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  appealList,
  deleteAppeal,
  appealExport
} from '@api/yardAppeal'
import {
  getArea
} from '@api/activityCenter/activityCenter'
export default {
  data() {
    return {
      areaList: [],
      ruleform: {
        keyWord: '', // 模糊搜索
        appealType: '', // 活动区域
        currentRole: '', // 视频状态
        county: '', // 所属区县
        process: '', // 诉求状态
        videoTime: '' // 视频时间
      },
      processList: [
        { value: 1, label: '受理中' },
        { value: 2, label: '已完结' },
        { value: 3, label: '已评价' }
      ], // 诉求状态
      roleList: ['市管理员', '信访办'],
      appealList: ['咨询', '求助', '建议', '投诉', '举报'],
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalRecord: 0
    }
  },
  computed: {
    handleStatus() {
      return number => {
        let val
        switch (number) {
          case 1:
            val = '受理中'
            break
          case 2:
            val = '已完结'
            break
          case 3:
            val = '已评价'
            break
        }
        return val
      }
    }
  },
  created() {
    this.getArea()
  },
  mounted() {
    this.listLiveData()
  },
  methods: {
    /** 获取丽水市以及各个区县 */
    getArea() {
      getArea({}).then(res => {
        if (res.data.code == '0000') {
          this.areaList = res.data.data || []
        }
      })
    },
    getSearch() {
      this.currentPage = 1
      this.listLiveData()
    },
    // 所有类别
    getPoss() {
      this.currentPage = 1
      this.listLiveData()
    },
    //  表格翻页
    handleCurrentChange(currentPage, e) {
      this.currentPage = currentPage
      this.listLiveData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.listLiveData()
    },
    edit(item) {
      this.$router.push({ name: 'appealDetail', query: { id: item.id, isHandle: item.isHandle }})
    },
    // 列表
    listLiveData() {
      let par = {
        current: this.currentPage,
        size: this.pageSize,
        keyWord: this.ruleform.keyWord,
        startTime: this.ruleform.videoTime ? this.ruleform.videoTime[0] : '',
        endTime: this.ruleform.videoTime ? this.ruleform.videoTime[1] : '',
        appealType: this.ruleform.appealType,
        currentRole: this.ruleform.currentRole,
        process: this.ruleform.process,
        county: this.ruleform.county
      }
      appealList(par).then(res => {
        if (res.data.code == '0000') {
          const list = res.data.data
          this.tableData = list.records || []
          this.totalRecord = list.total || 0
        }
      })
    },
    // 导出
    exportDefend() {
      let par = {
        keyWord: this.ruleform.keyWord,
        startTime: this.ruleform.videoTime ? this.ruleform.videoTime[0] : '',
        endTime: this.ruleform.videoTime ? this.ruleform.videoTime[1] : '',
        appealType: this.ruleform.appealType,
        currentRole: this.ruleform.currentRole,
        process: this.ruleform.process,
        county: this.ruleform.county
      }
      appealExport(par)
    },

    // 删除
    deleteEntTrain(id) {
      this.$confirm('是否确定删除码上诉求列表数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        deleteAppeal({ id: id }).then(res => {
          if (res.data.code == '0000') {
            this.$message.success('删除成功')
            this.listLiveData()
          } else {
            this.$message.error(res.data.msg || '删除诉求失败')
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  margin-bottom: 20px;
  .header-serach {
    .el-input {
      width: 230px;
      margin-right: 10px;
    }
  }
  .addPru {
    width: 100px;
    display: inline-block;
    text-align: center;
    position: absolute;
    right: 50px;
    height: 36px;
    border-radius: 5px;
    line-height: 36px;
    background: #1890ff;
    color: #fff;
    cursor: pointer;
  }
}
.actcolor {
  color: #1890ff;
}
.nocolor {
  color: rgba(0, 0, 0, 0.3);
}
.changeAppeal {
  cursor: pointer;
  color: #1890ff;
}
.el-table::before {
  height: 0px;
}
.table-page {
  width: 100%;
  text-align: center;
  margin-top: 24px;
  margin-bottom: 20px;
}
.sharing-code {
  display: flex;
  span {
    line-height: 34px;
  }
  /deep/.el-input__inner {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  /deep/.el-button--medium {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
.exhibition {
  // margin-top: 20px;
  margin-left: -25px;
  display: flex;
  #qrcode {
    width: 125px;
    height: 150px;
    margin: 20px auto;
  }
  .refreshs {
    margin: 20px auto;
    span {
      margin-left: 22px;
    }
    .refresh {
      margin-left: 50px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 300px;
}
.el-popover {
  min-width: 100px !important;
}
</style>
